module.exports = __webpack_public_path__ + "img/pic2.6fce4abd.jpg";